export const ENROLLMENT_TYPES = {
    account: 'ACCOUNT',
    policy: 'POLICY'
};

export function isPolicyEnrollment(enrollmentType) {
    return enrollmentType.toUpperCase() === ENROLLMENT_TYPES.policy;
}
